import frappe from '../frappe';

export async function updateThirdPartyPhone(customerName, newPhone) {
  try {
    const { data } = await frappe.put(`/api/resource/Customer/${customerName}`, {
      mobile_no: newPhone,
    });
    return data.data;
  } catch (error) {
    console.error('Error al actualizar teléfono:', error.response?.data || error.message);
    throw error;
  }
}
